(function () {
	"use strict";
	var MAX_INLINE_ITEMS = 10;
	var ROW_HEIGHT = 43; /* approx height of one .bmsel-card row */
	var VISIBLE_ROWS = 10.5;

	function injectStyle() {
		if (document.getElementById("bmsel-dd-style")) return;
		var style = document.createElement("style");
		style.id = "bmsel-dd-style";
		style.textContent =
			".bmsel-dd-wrap{position:relative;width:100%;max-width:340px;margin:0 auto;display:block}" +
			".bmsel-toggle{display:none;width:100%;margin:0;padding:9px 34px 9px 14px;border:2px solid #ddd;border-radius:5px;background:#fff;font-size:.9em;font-weight:600;color:#333;text-align:left;cursor:pointer;position:relative;box-sizing:border-box}" +
			".bmsel-toggle:after{content:'\\25BE';position:absolute;right:14px;top:50%;transform:translateY(-50%);color:#888;font-size:1.1em}" +
			".bmsel-toggle.is-open:after{content:'\\25B4'}" +
			".bmsel--dd .bmsel-toggle{display:block}" +
			".bmsel--dd .bmsel-dd-wrap .bmsel-grid{display:none;position:absolute;top:100%;left:0;right:0;margin-top:4px;box-sizing:border-box;padding:0;max-height:" + (ROW_HEIGHT * VISIBLE_ROWS) + "px;overflow-y:auto;border:1px solid #e2e2e2;border-radius:5px;background:#fff;box-shadow:0 6px 20px rgba(0,0,0,.16);z-index:60;-webkit-overflow-scrolling:touch}" +
			".bmsel--dd .bmsel-dd-wrap .bmsel-grid.is-open{display:block}" +
			".bmsel--dd .bmsel-card{display:block;width:100%;box-sizing:border-box;text-align:left;border:none;border-bottom:1px solid #eee;border-radius:0;margin:0;padding:10px 14px}" +
			".bmsel--dd .bmsel-card:last-child{border-bottom:none}" +
			".bmsel-search{display:block;position:sticky;top:0;width:100%;box-sizing:border-box;margin:0;padding:9px 12px;border:none;border-bottom:1px solid #e2e2e2;font-size:.9em;color:#333;background:#fff;z-index:2}" +
			".bmsel-search:focus{outline:none;background:#fafafa}" +
			".bmsel-no-results{display:none;padding:14px;text-align:center;color:#888;font-size:.85em}";
		document.head.appendChild(style);
	}

	function enhanceGrid(grid) {
		var items = Array.prototype.slice.call(grid.querySelectorAll(".bmsel-card"));
		if (items.length <= MAX_INLINE_ITEMS) return;
		var wrap = grid.closest(".bmsel");
		if (!wrap || wrap.classList.contains("bmsel--dd")) return;

		wrap.classList.add("bmsel--dd");

		var label = "Select";
		var ttl = wrap.querySelector(".bmsel-ttl");
		if (ttl && ttl.textContent) {
			label = ttl.textContent.trim().replace(/:$/, "");
		}

		var ddWrap = document.createElement("div");
		ddWrap.className = "bmsel-dd-wrap";

		var toggle = document.createElement("button");
		toggle.type = "button";
		toggle.className = "bmsel-toggle";
		toggle.textContent = "View all";
		toggle.setAttribute("aria-expanded", "false");
		toggle.setAttribute("aria-label", label + " - view all options");

		var search = document.createElement("input");
		search.type = "text";
		search.className = "bmsel-search";
		search.placeholder = "Search " + label.replace(/^Choose Your /i, "") + "…";
		search.setAttribute("aria-label", "Search " + label);

		var noResults = document.createElement("div");
		noResults.className = "bmsel-no-results";
		noResults.textContent = "No matches";

		grid.parentNode.insertBefore(ddWrap, grid);
		ddWrap.appendChild(toggle);
		ddWrap.appendChild(grid);
		grid.insertBefore(noResults, grid.firstChild);
		grid.insertBefore(search, grid.firstChild);

		function filter(query) {
			var q = query.trim().toLowerCase();
			var anyVisible = false;
			items.forEach(function (item) {
				var match = q === "" || item.textContent.toLowerCase().indexOf(q) !== -1;
				item.style.display = match ? "" : "none";
				if (match) anyVisible = true;
			});
			noResults.style.display = anyVisible ? "none" : "block";
		}

		search.addEventListener("input", function () {
			filter(search.value);
		});
		search.addEventListener("click", function (e) {
			e.stopPropagation();
		});

		function closeDropdown() {
			grid.classList.remove("is-open");
			toggle.classList.remove("is-open");
			toggle.setAttribute("aria-expanded", "false");
			search.value = "";
			filter("");
		}

		toggle.addEventListener("click", function (e) {
			e.stopPropagation();
			var open = grid.classList.toggle("is-open");
			toggle.classList.toggle("is-open", open);
			toggle.setAttribute("aria-expanded", open ? "true" : "false");
			if (open) {
				window.setTimeout(function () { search.focus(); }, 0);
			} else {
				search.value = "";
				filter("");
			}
		});

		document.addEventListener("click", function (e) {
			if (grid.classList.contains("is-open") && !ddWrap.contains(e.target)) {
				closeDropdown();
			}
		});

		document.addEventListener("keydown", function (e) {
			if (e.key === "Escape" && grid.classList.contains("is-open")) {
				closeDropdown();
			}
		});
	}

	function run() {
		var grids = document.querySelectorAll(".bmsel-grid");
		if (!grids.length) return;
		injectStyle();
		grids.forEach(enhanceGrid);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", run);
	} else {
		run();
	}
})();
